/// <reference types="@angular/localize" />

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import flatpickr from 'flatpickr';
import { Spanish } from 'flatpickr/dist/l10n/es.js';

// ✅ Localización global a español
flatpickr.localize(Spanish);

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
